import React from "react";

const StatusContext = React.createContext({});

export default StatusContext;
